import loadable from "@loadable/component";
import { useParams } from "react-router";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditPaymentMethodComponent = loadable(
  () => import("../../components/PaymentMethod/EditPaymentMethod")
);
const EditPaymentMethod = () => {
  const { id } = useParams();

  const { refetch } = useGetHook({
    queryKey: ["payment-method"],
    url: `${APIS.PAYMENT_METHOD}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["payment-method"],
    navigateURL: "/",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.PAYMENT_METHOD}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Payment Method
        </span>
      </div>
      <EditPaymentMethodComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditPaymentMethod;
